import React from "react";
import RegisterPage, { STATUS_BADGES, StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";
import { apiFetch } from "../lib/api";

export default function WorkerConsultation() {
  const { data, siteNames } = useHSE();
  const rows = data.workerConsultations || [];

  const handleSaveRecord = async (editingRecord) => {
    try {
      const res = await apiFetch("/worker-consultations", {
        method: "POST",
        body: {
          ...editingRecord,
          idempotencyKey: `wcn-${editingRecord.id}`,
        },
      });
      return res?.item ? { ...editingRecord, ...res.item } : editingRecord;
    } catch (err) {
      return editingRecord;
    }
  };

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <StatCard label="Consultation Sessions" value={rows.length} testid="wcn-total" />
      <StatCard label="Committees" value={rows.filter((r) => r.consultationMethod === "committee").length} tone="info" />
      <StatCard label="Toolbox Talks" value={rows.filter((r) => r.consultationMethod === "toolbox_talk").length} tone="safe" />
      <StatCard label="Open Concerns" value={rows.filter((r) => r.status !== "closed").length} tone="warning" />
    </div>
  );

  return (
    <RegisterPage
      title="Worker Consultation & Participation"
      subtitle="ISO 45001 Clause 5.4 — Safety Committees, Toolbox Consultations, Worker Feedback & Agreed Decisions"
      storeKey="workerConsultations"
      idPrefix="WCN"
      topPanels={Top}
      onSaveRecord={handleSaveRecord}
      columns={[
        { key: "id", label: "WCN ID" },
        { key: "topic", label: "Consultation Topic" },
        { key: "consultationMethod", label: "Method", render: (r) => <span className="uppercase text-[10px] font-bold px-2 py-0.5 rounded bg-slate-100 text-slate-700">{r.consultationMethod || "committee"}</span> },
        { key: "consultationDate", label: "Date" },
        { key: "participantsCount", label: "Participants", render: (r) => <span className="font-semibold">{r.participantsCount || 0}</span> },
        { key: "concernsRaised", label: "Concerns Raised" },
        { key: "decisionsAgreed", label: "Agreed Decisions" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ status: STATUS_BADGES }}
      formFields={[
        { key: "id", label: "Record ID" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "topic", label: "Consultation Topic" },
        { key: "consultationMethod", label: "Method", type: "select", options: ["committee", "toolbox_talk", "survey", "focus_group", "safety_rep"] },
        { key: "consultationDate", label: "Consultation Date", type: "date" },
        { key: "participantsCount", label: "Number of Participants", type: "number" },
        { key: "concernsRaised", label: "Worker Concerns Raised", type: "textarea", full: true },
        { key: "decisionsAgreed", label: "Agreed Decisions & Actions", type: "textarea", full: true },
        { key: "feedbackSummary", label: "Feedback Summary", type: "textarea", full: true },
        { key: "status", label: "Status", type: "select", options: ["open", "in_progress", "closed"] },
      ]}
    />
  );
}
